import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BiErrorCircle } from "react-icons/bi";
import { UserContext } from "../contexts/UserContext";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { clearUserData } = useContext(UserContext);

  const handleBackHome = () => {
    clearUserData();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="p-8 bg-white shadow-lg rounded-lg flex items-center space-x-4">
          <BiErrorCircle className="text-yellow-500 text-8xl" />
          <h1 className="text-4xl font-bold mt-6 text-gray-800">
            404- Seite nicht gefunden
          </h1>
        </div>
        <p className="text-lg text-gray-600 mt-4">
          The page you are looking for does not exist.
        </p>
        <button
          onClick={handleBackHome}
          className="mt-6 bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-600 focus:outline-none"
        >
          Zurück zum Login
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
